import axios from 'axios';

class TrialRequestForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.elem.submitBtn = self.elem.querySelector('[data-trial-request-form-submit]');
        self.postUrl = self.elem.getAttribute('data-api-url');
        self.successAlert = document.querySelector('[data-trial-request-success-alert]');
    }

    init() {
        let self = this;

        self.elem.addEventListener('submit', evt => {
            evt.preventDefault();

            self.submitForm();
        });
    }

    formDataAsJson() {
        let self = this;

        let formData = {};

        formData.full_name = self.elem.querySelector('[data-input-full-name]').value;
        formData.job_title = self.elem.querySelector('[data-input-job-title]').value;
        formData.institution = self.elem.querySelector('[data-input-institution]').value;
        formData.address = self.elem.querySelector('[data-input-address]').value;
        formData.country = '';
        formData.email = self.elem.querySelector('[data-input-email]').value;
        formData.where_did_you_hear_about_us = '';
        formData.other = '';
        formData.products = [...self.elem.querySelectorAll('[data-input-product]:checked')].map(product => parseInt(product.value));
        formData.trial_access = self.elem.querySelector('[data-input-trial-access]:checked').value;
        formData.ip_address_list = [...self.elem.querySelectorAll('[data-input-ip-address-list]')].map(ipAddress => ipAddress.value);

        return formData;
    }

    submitForm(evt) {
        let self = this;

        // Disable submit button
        self.elem.submitBtn.disabled = true;

        axios.post(self.postUrl, self.formDataAsJson())
        .then(function (response) {
            // Submit the form
            self.elem.submit();
            
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}

export default TrialRequestForm;
